<template>
  <v-container fluid fill-height grid-list-xs pa-0>
    <v-layout row wrap align-stretch>
      <v-form v-model="valid">
        <v-layout row wrap justify-center>
          <v-flex xs3 md2>
            <v-select
              :items="filtros"
              item-text="title"
              label="Filtros"
              item-value="value"
              v-model="filtro"
            >
            </v-select>
          </v-flex>
          <v-flex xs3 md2>
            <v-text-field
              placeholder="Identificação do cliente"
              class="pr-3"
              v-model="opcoes.id_pessoa"
            ></v-text-field>
          </v-flex>
          <v-flex xs3 md2>
            <v-text-field
              placeholder="CPF"
              mask="###.###.###-##"
              class="pr-3"
              v-model="opcoes.masked_cpf"
              return-masked-value
              :rules="[rules.cpf]"
            ></v-text-field>
          </v-flex>
          <v-flex xs3 md2 shrink>
            <v-text-field
              placeholder="Código"
              v-model="opcoes.codigo"
            ></v-text-field>
          </v-flex>
          <v-flex xs3 md2>
            <v-select
              label="Combustível"
              :items="combustiveis"
              item-text="nome"
              item-value="id_combustivel"
              clearable
              v-model="opcoes.id_combustivel"
            >
              <template v-slot:item="data">
                <svg-filler :path="require(`@/assets/combs/${data.item.icone}.svg`)" width="35px" height="35px" :fill="data.item.color"/>
                {{data.item.nome}}
              </template>
              <template v-slot:selection="data">
                <svg-filler :path="require(`@/assets/combs/${data.item.icone}.svg`)" width="35px" height="35px" :fill="data.item.color"/>
                {{data.item.nome}}
              </template>
            </v-select>
          </v-flex>
          <v-flex xs3 md1>
            <v-select
              :items="options"
              item-text="title"
              item-value="value"
              v-model="selectOpcoes"
            >
            </v-select>
          </v-flex>
          <v-flex xs4 :md3="opcoes.custom" :md2="!opcoes.custom">
            <v-menu
              ref="menuDataInicial"
              v-model="menuDataInicial"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-combobox
                  v-if="opcoes.custom"
                  v-model="opcoes.intervalo_relatorio"
                  label="Dias"
                  multiple
                  persistent-hint
                  chips
                  small-chips
                  readonly
                  flat
                  prepend-icon="event"
                  required
                  v-on="on"
                  clearable
                ></v-combobox>
                <v-combobox
                  v-else-if="opcoes.dia"
                  v-model="opcoes.data_relatorio"
                  label="Dia"
                  persistent-hint
                  chips
                  small-chips
                  readonly
                  flat
                  @blur="date = parseDate(opcoes.data_relatorio)"
                  prepend-icon="event"
                  required
                  v-on="on"
                  clearable
                ></v-combobox>
                <v-combobox
                  v-else
                  v-model="opcoes.mes_relatorio"
                  label="Mes"
                  persistent-hint
                  chips
                  small-chips
                  readonly
                  flat
                  @blur="month = parseDate(opcoes.mes_relatorio)"
                  prepend-icon="event"
                  required
                  v-on="on"
                  clearable
                ></v-combobox>
              </template>
              <v-date-picker v-show="opcoes.custom" multiple v-model="dates" type="date" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
              <v-date-picker v-show="opcoes.dia" v-model="date" type="date" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
              <v-date-picker v-show="opcoes.mes" v-model="month" type="month" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs3 md2>
              <v-select
                :items="[
                  { text: 'todos', value: null },
                  { text: 'clientes', value: true },
                  { text: 'empresas', value: false }
                ]"
                item-text="text"
                label="Tipo de comprador"
                item-value="value"
                v-model="opcoes.tipo_comprador"
              ></v-select>
            </v-flex>
          <v-flex shrink>
             <v-btn icon color="info" @click="carregarRelatorio(true)"><v-icon>search</v-icon></v-btn>
           </v-flex>
          <v-flex shrink>
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                >
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-tile
                  @click="editando = !editando"
                >
                  <v-list-tile-action>
                    <v-icon v-if="!editando">edit</v-icon>
                    <v-icon v-else>done</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>Editar relatório</v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  @click="print()"
                >
                  <v-list-tile-action>
                    <v-icon>print</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>Imprimir relatório</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-form>
      <v-flex xs12 class="print">
        <div class="pb-3 pt-5 hide-display">
          <v-layout row>
            <h1> Relatório de compras</h1>
            <v-spacer></v-spacer>
            <span class="display-2">Total: {{ total_relatorio_compras | currency({ fractionCount: 2 }) }}</span>
          </v-layout>
          <hr/>
        </div>
        <v-data-table
          hide-actions
          :hide-headers="!compras || !compras.length"
          :loading="loading"
          :items="compras"
          :pagination.sync="pagination"
          :total-items="totalItens"
          class="elevation-1"
        >
          <v-alert v-slot:no-results :value="true" color="error" icon="warning">
            Desculpe, não encontramos nenhum dado!
          </v-alert>
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center px-0" style="width: 60px"  v-if="headersVisible.combustivel">
                  <v-tooltip class="hidden-print-only" :color="props.item.combustivel.color" top>
                      <template v-slot:activator="{ on }">
                          <span class="hidden-print-only" v-on="on">
                              <svg-filler :path="require(`@/assets/combs/${props.item.combustivel.icone}.svg`)" width="40px" height="40px" :fill="props.item.combustivel.color"/>
                          </span>
                      </template>
                      <span>{{props.item.combustivel.nome}}</span>
                  </v-tooltip>
                  <span class="hidden-screen-only">{{props.item.combustivel.nome}}</span>
              </td>
              <td class="text-xs-left px-3"  style="width: 110px" v-if="headersVisible.data_compra">{{ props.item.data_compra.split('-').reverse().join('-') }}</td>
              <td class="text-xs-left" v-if="headersVisible.id_pessoa">
                {{`${props.item.cliente.pessoa.nome} ${props.item.cliente.pessoa.sobrenome}` | truncate(30) }}
                <div><strong>{{props.item.cliente.pessoa.id_pessoa}}</strong></div>
              </td>
              <td class="text-xs-left" v-if="headersVisible.desconto">
                {{getDesconto(props.item)}}
              </td>
              <td class="text-xs-left" style="width: 200px"  v-if="headersVisible.tid">
                {{props.item.token}}
                <div>NSU: <strong>{{props.item.nsu}}</strong></div>
                <div v-if="props.item.brand && props.item.card">Cartão: <strong>{{props.item.brand}} - Final: {{props.item.card.substr(props.item.card.length - 4)}}</strong></div>
              </td>
              <td class="text-xs-right pl-2 pr-4"  style="width: 120px" v-if="headersVisible.valor">{{ props.item.valor | currency({ fractionCount: 2 }) }}</td>
              <td class="text-xs-center px-0" style="width: 40px" v-if="headersVisible.pagamento">
                <v-tooltip v-if="props.item.em_especie" top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="teal">attach_money</v-icon>
                  </template>
                  <span>Em dinheiro</span>
                </v-tooltip>
                <v-tooltip v-else top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="teal">payment</v-icon>
                  </template>
                  <span>No cartão</span>
                </v-tooltip>
              </td>
              <td class="text-xs-center px-0" style="width: 40px" v-if="headersVisible.confirmada">
                <v-tooltip v-if="props.item.confirmado" top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="teal">done_all</v-icon>
                    </template>
                    <span>Confirmada</span>
                </v-tooltip>
                <v-tooltip v-else top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="red">close</v-icon>
                    </template>
                    <span>Pagamento não efetuado</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:headers>
            <tr>
              <th class="text-xs-left px-4" v-if="headersVisible.combustivel">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.combustivel = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
              </th>
              <th class="text-xs-left  px-3" v-if="headersVisible.data_compra">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.data_compra = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Data
              </th>
              <th class="text-xs-left" v-if="headersVisible.id_pessoa">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.id_pessoa = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Cliente
              </th>
              <th class="text-xs-left" v-if="headersVisible.desconto">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.desconto = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Desconto
              </th>
              <th class="text-xs-left" v-if="headersVisible.tid">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.tid = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                ID da transação
              </th>
              <th class="text-xs-right pl-2 pr-4" v-if="headersVisible.valor">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.valor = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Valor (R$)
              </th>
              <th class="text-xs-center px-4" v-if="headersVisible.pagamento">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.pagamento = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
              </th>
              <th class="text-xs-center px-4" v-if="headersVisible.confirmada">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.confirmada = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
              </th>
            </tr>
          </template>
        </v-data-table>
        <div class="text-xs-center">
          <v-pagination v-model="pagination.page" :length="pages" circle></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    <v-footer
      absolute
      dense
      style="background: transparent"
    >
      <v-expand-transition>
        <v-toolbar dense v-show="compras.length">
          <v-toolbar-title>
            Valor com desconto: {{ valor_desconto | currency({ fractionCount: 2 }) }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title>
            Total: {{ total_relatorio_compras | currency({ fractionCount: 2 }) }}
          </v-toolbar-title>
        </v-toolbar>
      </v-expand-transition>
    </v-footer>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      valor_desconto: 0,
      valid: false,
      combustivel: '',
      filtro: 'confirmadas',
      editando: false,
      menuDataInicial: false,
      date: moment().format(`YYYY-MM-DD`),
      month: new Date().toISOString().substr(0, 10),
      dates: [],
      totalItens: 0,
      headersVisible: {
        desconto: true,
        combustivel: true,
        data_compra: true,
        pagamento: true,
        confirmada: true,
        tid: true,
        id_pessoa: true,
        masked_cpf: true,
        litrosTotal: true,
        litrosUsados: true,
        litrosRestante: true,
        valor: true,
        avatar: true
      },
      rules: {
        cpf: value => {
          const pattern = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/
          return !value || pattern.test(value) || 'CPF inválido.'
        }
      },
      today: null,
      selectOpcoes: 'dia',
      filtros: [
        {
          title: 'Confirmadas',
          value: 'confirmadas'
        },
        {
          title: 'Todas',
          value: 'todas'
        }
      ],
      options: [
        {
          title: 'Dia',
          value: 'dia'
        },
        {
          title: 'Mês',
          value: 'mes'
        },
        {
          title: 'Intervalo',
          value: 'custom'
        }
      ],
      opcoes: {
        dia: true,
        custom: false,
        mes: false,
        data_relatorio: moment().format(`DD/MM/YYYY`),
        mes_relatorio: null,
        intervalo_relatorio: [],
        id_combustivel: null,
        confirmadas: true,
        id_pessoa: null,
        masked_cpf: undefined,
        nsu: null,
        tipo_comprador: null,
        codigo: null
      },
      pagination: {
        page: 1,
        rowsPerPage: 20
      }
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalItens == null
      ) return 0

      const pages = Math.ceil(this.totalItens / this.pagination.rowsPerPage)
      return pages
    },
    compras () {
      return this.$store.getters.compras_no_posto
    },
    posto () {
      return this.$store.getters.posto
    },
    loading () {
      return this.$store.getters.loading
    },
    combustiveis () {
      return this.$store.getters.combustiveis
    },
    total_relatorio_compras () {
      return this.$store.getters.total_relatorio_compras_posto
    },
    tempOpcoes () {
      let tempOpcoes = {
        run: true
      }

      if (this.opcoes.tipo_comprador !== null && this.opcoes.tipo_comprador !== undefined) {
        tempOpcoes.is_empresa = this.opcoes.tipo_comprador
      }

      if (this.filtro !== 'todas') {
        tempOpcoes['confirmado'] = true
        tempOpcoes['recompra'] = false
      }
      // if (this.filtro === 'confirmadas') {
      //   tempOpcoes['em_especie'] = false
      // }
      this.opcoes.codigo && this.opcoes.codigo !== '' && (tempOpcoes['vouchers__numero'] = this.opcoes.codigo)
      this.opcoes.id_combustivel && (tempOpcoes['combustivel'] = this.opcoes.id_combustivel)
      this.opcoes.id_pessoa && this.opcoes.id_pessoa !== '' && (tempOpcoes['cliente__pessoa'] = this.opcoes.id_pessoa)
      this.valid && this.opcoes.masked_cpf && this.opcoes.masked_cpf !== '' && (tempOpcoes['cliente__pessoa__cpf'] = this.opcoes.masked_cpf.replace(/[^\d]+/g, ''))

      // Validando as datas
      if (this.opcoes.custom && this.opcoes.intervalo_relatorio && this.opcoes.intervalo_relatorio.length === 2) {
        tempOpcoes['data_compra__gte'] = this.opcoes.intervalo_relatorio[0]
        tempOpcoes['data_compra__lte'] = this.opcoes.intervalo_relatorio[1]
      } else if (this.opcoes.dia && this.date) {
        tempOpcoes['data_compra'] = this.date.split('-').reverse().join('/')
      } else if (this.opcoes.mes && this.month && this.month.length) {
        const initialDate = new Date(`${this.month.split('-')[1]}-01-${this.month.split('-')[0]}`.split('-').join('/'))
        const finalDate = new Date(initialDate.getFullYear(), initialDate.getMonth() + 1, 0)

        tempOpcoes['data_compra__gte'] = initialDate.toISOString().substr(0, 10).split('-').reverse().join('/')
        tempOpcoes['data_compra__lte'] = finalDate.toISOString().substr(0, 10).split('-').reverse().join('/')
      } else {
        tempOpcoes['run'] = false
      }
      return tempOpcoes
    }
  },
  watch: {
    pagination: {
      handler (val) {
        this.carregarRelatorio(false)
      },
      deep: true
    },
    filtro (val) {
      if (val === 'confirmadas') {
        this.opcoes.confirmadas = true
      } else {
        this.opcoes.confirmadas = false
      }
    },
    date (val) {
      if (val) {
        this.opcoes.data_relatorio = this.formatDate(this.date)
      }
    },
    month (val) {
      if (val) {
        this.opcoes.mes_relatorio = this.formatDate(this.month)
      }
    },
    selectOpcoes (val) {
      this.limparOpcoes()
      if (val === 'dia') {
        this.opcoes.dia = true
        this.opcoes.data_relatorio = this.formatDate(this.date)
      } else if (val === 'custom') {
        this.opcoes.custom = true
        this.opcoes.data_relatorio = this.formatDate(this.date)
      } else if (val === 'mes') {
        this.opcoes.mes = true
        this.opcoes.mes_relatorio = this.formatDate(this.month)
      }
    },
    posto (val, oldval) {
      if (!oldval && val) {
        this.$store.dispatch('carregarCombustiveis')
      }
    }
  },
  mounted () {
    this.today = new Date().setHours(0, 0, 0, 0)
    if (this.posto) {
      this.$store.dispatch('carregarCombustiveis')
    }
  },
  methods: {
    print () {
      window.print()
    },
    getDesconto (compra) {
      if (!compra) return ''
      if (compra.oferta && compra.oferta.promocao) return `Promoção de ${compra.oferta.percentual_desconto || 0}%`
      else if (compra.oferta && !compra.oferta.promocao) return `Oferta de ${compra.oferta.percentual_desconto || 0}%`
      if (compra.codigo_promocional) return `Código promocional de ${compra.codigo_promocional.desconto || 0}%`
      if (compra.convenio_posto) return `Convêncio de ${compra.convenio_posto.desconto || 0}%`
      if (compra.proposta) return `Proposta de ${compra.proposta.desconto || 0}%`
      else return 'Sem oferta'
    },
    formatDate (date) {
      if (!date) return null

      if (this.opcoes.dia || this.opcoes.custom) {
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      } else {
        const [year, month] = date.split('-')
        return `${month}/${year}`
      }
    },
    orderDates () {
      this.dates.sort((a, b) => {
        a = new Date(a.split('-'))
        b = new Date(b.split('-'))
        return a < b ? -1 : a > b ? 1 : 0
      })
    },
    parseDate (date) {
      if (!date) return null

      if (this.opcoes.dia || this.opcoes.custom) {
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      } else {
        const [month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}`
      }
    },
    limparOpcoes () {
      this.opcoes.dia = false
      this.opcoes.custom = false
      this.opcoes.mes = false
    },
    carregarRelatorio (zerarPaginacao) {
      if (zerarPaginacao) this.pagination.page = 1
      this.$store.dispatch('relatorioComprasNoPosto', { filtro: this.tempOpcoes, pagination: this.pagination }).then(json => {
        this.totalItens = json.count
        this.valor_desconto = json.results.valor
      })
    },
    dataSelecionada () {
      if (this.opcoes.custom) {
        if (this.dates.length === 3) {
          let day1 = this.dates[0]
          let day2 = this.dates[2]
          this.dates = []
          this.dates = [day1, day2]
        }
        if (this.dates.length) {
          this.orderDates()
        }
        this.opcoes.intervalo_relatorio = this.dates.map(this.formatDate)
      } else {
        this.menuDataInicial = false
      }
    }
  }
}
</script>
